"use client";

import { c as _c } from "react/compiler-runtime";
import { Box, Container, Paper, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { useAppContext } from "@/app/contextProviders/app-context";
import { NO_SIDEBAR_STEP_INDEX } from "@/lib/machines/machine-state-mapping";
import { StepSidebar } from "./StepSidebar";
import styles from "./Stepper.module.css";
interface StepPanelProps {
  children: React.ReactNode;
  step?: number;
}
export function StepPanel(t0) {
  const $ = _c(16);
  const {
    children,
    step: t1
  } = t0;
  const step = t1 === undefined ? 0 : t1;
  const theme = useTheme();
  const {
    deviceType
  } = useAppContext();
  let t2;
  if ($[0] !== theme.breakpoints) {
    t2 = theme.breakpoints.down("sm");
    $[0] = theme.breakpoints;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = deviceType === "mobile";
  let t4;
  if ($[2] !== t3) {
    t4 = {
      defaultMatches: t3
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const isSmallScreen = useMediaQuery(t2, t4);
  const isFirstStep = step === NO_SIDEBAR_STEP_INDEX;
  let t5;
  if ($[4] !== children || $[5] !== isFirstStep || $[6] !== isSmallScreen || $[7] !== step) {
    t5 = !isFirstStep && <StepSidebar activeStep={step}>{isSmallScreen ? children : null}</StepSidebar>;
    $[4] = children;
    $[5] = isFirstStep;
    $[6] = isSmallScreen;
    $[7] = step;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== children || $[10] !== isFirstStep || $[11] !== isSmallScreen) {
    t6 = (!isSmallScreen || isFirstStep) && <Box data-step-content={true} sx={{
      ...(isFirstStep && {
        gridColumn: "1 / -1",
        display: "flex",
        justifyContent: "center"
      })
    }} className={isFirstStep ? undefined : styles.panelBody}><Box>{children}</Box></Box>;
    $[9] = children;
    $[10] = isFirstStep;
    $[11] = isSmallScreen;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <Paper className={styles.panel} elevation={0}><Container maxWidth="lg" disableGutters={true}><Box className={styles.stepperContainer}>{t5}{t6}</Box></Container></Paper>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}